import { UnpaidInvoiceSortField } from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-list';

interface UnpaidInvoicesTableColumn {
  initialPercentWidth: number;
  labelKey: string;
  minSize?: number;
  sortField: UnpaidInvoiceSortField;
}

export const UNPAID_INVOICES_TABLE_COLUMNS: UnpaidInvoicesTableColumn[] = [
  {
    initialPercentWidth: 15,
    labelKey: 'finance_hub.invoices.table.column.due_date',
    sortField: 'dueDate',
  },
  {
    initialPercentWidth: 13,
    labelKey: 'finance_hub.invoices.table.column.invoice',
    sortField: 'invoiceNumber',
  },
  {
    initialPercentWidth: 20,
    labelKey: 'finance_hub.invoices.table.column.customer',
    sortField: 'customerName',
  },
  {
    initialPercentWidth: 18,
    labelKey: 'finance_hub.invoices.table.column.remaining_balance',
    sortField: 'remainingBalance',
  },
  {
    initialPercentWidth: 16,
    labelKey: 'finance_hub.invoices.table.column.overdue',
    minSize: 120,
    sortField: 'daysOverdue',
  },
  {
    initialPercentWidth: 18,
    labelKey: 'finance_hub.invoices.table.column.last_synced',
    sortField: 'erpLastSyncedAt',
  },
];

export const UNPAID_INVOICES_TABLE_ROW_HEIGHT = 68;
